<template>
    <div>
        <div v-if="isPending">
            <round-progress-bar v-bind:percents="progress" />
        </div>
        <div v-else-if="isTickTock"
            class="tx-mobile-overview-icon"
            v-bind:class="{
                'tx-mobile-overview-icon--failed': traceStatus === false,
            }"
        >
            <icon-service />
        </div>
        <div v-else-if="!simplePreview || !isTxSimple"
            class="tx-mobile-overview-icon"
            v-bind:class="{
                'tx-mobile-overview-icon--failed': traceStatus === false,
                'tx-mobile-overview-icon--skeleton': !getIcon || traceStatus === undefined,
            }"
        >
            <component v-if="getIcon" v-bind:is="getIcon" />
        </div>
        <div v-else>
            <template v-if="simplePreview.event === 'nft_transfer' || simplePreview.event === 'nft_purchase'">
                <img
                    v-show="!nftError && simplePreview.meta?.image"
                    v-bind:src="simplePreview.meta?.image"
                    class="tx-mobile-overview-nft"
                    v-on:error="nftError = true"
                />
                <div v-show="nftError || !simplePreview.meta?.image" class="tx-mobile-overview-nft">
                    <icon-nft />
                </div>
            </template>
            <div class="tx-mobile-overview-swap" v-else-if="simplePreview.event === 'jetton_swap'">
                <ui-round-image
                    class="tx-mobile-overview-swap-logo tx-mobile-overview-swap-logo--left"
                    v-bind:src="simplePreview.meta.image_in" />
                <ui-round-image
                    class="tx-mobile-overview-swap-logo tx-mobile-overview-swap-logo--right"
                    v-bind:src="simplePreview.meta.image_out" />
            </div>
            <div class="tx-mobile-overview-swap" v-else-if="simplePreview.event === 'sent_jetton' || simplePreview.event === 'received_jetton' || simplePreview.event === 'jetton_burn'"    >
                <ui-round-image
                    class="tx-mobile-overview-swap-logo"
                    v-bind:src="simplePreview.meta.image" />
            </div>
            <div v-else-if="simplePreview.event && getIcon"
                class="tx-mobile-overview-icon"
                v-bind:class="{
                    'tx-mobile-overview-icon--failed': traceStatus === false,
                    'tx-mobile-overview-icon--skeleton': !getIcon || traceStatus === undefined,
                }"
            >
                <component v-bind:is="getIcon" />
            </div>
        </div>
    </div>
</template>

<script>
import IconIn from '@img/icons/tonscan/transactions/tx-in.svg?vue';
import IconOut from '@img/icons/tonscan/transactions/tx-out.svg?vue';
import IconBurn from '@img/icons/tonscan/transactions/tx-burn.svg?vue';
import IconJettonMint from '@img/icons/tonscan/transactions/tx-jetton-mint.svg?vue';
import IconNftIn from '@img/icons/tonscan/transactions/tx-nft-in.svg?vue';
import IconNftOut from '@img/icons/tonscan/transactions/tx-nft-out.svg?vue';
import IconNftBuy from '@img/icons/tonscan/transactions/tx-nft-buy.svg?vue';
import IconNftMint from '@img/icons/tonscan/transactions/tx-nft-mint.svg?vue';
import IconSwap from '@img/icons/tonscan/transactions/tx-swap.svg?vue';
import IconContractDeploy from '@img/icons/tonscan/transactions/tx-contract-deploy.svg?vue';
import IconSmartContractExec from '@img/icons/tonscan/transactions/tx-contract.svg?vue';
import IconStakeIn from '@img/icons/tonscan/transactions/tx-stake-in.svg?vue';
import IconStakeOut from '@img/icons/tonscan/transactions/tx-stake-out.svg?vue';
import IconStakePush from '@img/icons/tonscan/transactions/tx-stake-push.svg?vue';
import IconStakeDeposit from '@img/icons/tonscan/transactions/tx-stake-deposit.svg?vue';
import IconStakeWithdraw from '@img/icons/tonscan/transactions/tx-stake-withdraw.svg?vue';
import IconAuctionBid from '@img/icons/tonscan/transactions/tx-bid.svg?vue';
import IconSubscribe from '@img/icons/tonscan/transactions/tx-sub.svg?vue';
import IconUnsubscribe from '@img/icons/tonscan/transactions/tx-unsub.svg?vue';
import IconDomainRenew from '@img/icons/tonscan/domain_renew.svg?vue';
import IconUpdate from '@img/icons/tonscan/transactions/tx-update.svg?vue';
import IconCheck from '@img/icons/tonscan/transactions/tx-check.svg?vue';

import IconNft from '@img/icons/tonscan/nft-14.svg?inline';
import IconSuccess from '@img/icons/tonscan/transactions/tx-checks.svg?inline';
import IconFailed from '@img/icons/tonscan/transactions/tx-failed.svg?inline';
import IconService from '@img/icons/tonscan/transactions/tx-update.svg?inline';
import UiInlineNft from '~/components/address/TxRowInlineNft.vue';
import RoundProgressBar from '~/components/tx/Mobile/RoundProgressBar.vue'; /* eslint-disable "quote-props" */

/* eslint-disable "quote-props" */
const iconMap = Object.freeze({
    ton_transfer: IconOut,
    received_ton: IconIn,
    sent_ton: IconOut,
    jetton_transfer: IconOut,
    received_jetton: IconIn,
    sent_jetton: IconOut,
    auction_bid: IconAuctionBid,
    contract_deploy: IconContractDeploy,
    call_contract: IconSmartContractExec,
    deploy_nft: IconNftMint,
    nft_transfer: IconNftOut,
    stake_deposit: IconStakeDeposit,
    renew_dns: IconDomainRenew,
    election_deposit: IconStakeOut,
    election_recover: IconStakeIn,
    jetton_mint: IconJettonMint,
    jetton_burn: IconBurn,
    jetton_swap: IconSwap,
    nft_purchase: IconNftBuy,
    nft_mint: IconNftBuy,
    received_nft: IconNftIn,
    sent_nft: IconNftOut,
    subscribe: IconSubscribe,
    unsubscribe: IconUnsubscribe,
    stake_withdrawal: IconStakeWithdraw,
    stake_withdrawal_request: IconStakeIn,
    change_dns: IconDomainRenew,
    delete_dns: IconDomainRenew,
    dex_deposit_liquidity: IconStakeDeposit,
    dex_withdraw_liquidity: IconStakeWithdraw,
    multisig_execute: IconSmartContractExec,
    multisig_approve: IconCheck,
    multisig_create_order: IconStakePush,
    jvault_stake: IconStakeDeposit,
    jvault_unstake: IconStakeWithdraw,
    jvault_claim: IconStakeIn,
    vesting_add_whitelist: IconUpdate,
    vesting_send_message: IconSmartContractExec,
    evaa_supply: IconStakeDeposit,
    evaa_withdraw: IconStakeWithdraw,
    evaa_liquidate: IconSmartContractExec,
});

export default {
    props: {
        event: String,
        traceActions: Array,
        traceStatus: Boolean,
        isPending: Boolean,
        progress: [Number, String],
        isTxSimple: Boolean,
        isTickTock: Boolean,
    },

    data() {
        return {
            nftError: false,
        };
    },

    computed: {
        getIcon() {
            if (this.traceStatus === undefined) return null;
            if (!this.isTxSimple) {
                return this.traceStatus ? IconSuccess : IconFailed;
            }
            const type = this.traceActions[0]?.type;
            return iconMap[type] || IconOut;
        },
        simplePreview() {
            return this.traceActions && this.traceActions[0]?.simple_preview;
        },
    },

    components: {
        RoundProgressBar,
        UiInlineNft,
        IconNft,
        IconService,
    },
};
</script>

<style lang="scss">
.tx-mobile-overview-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    color: white;
    background: linear-gradient(135deg, #12a488, #30C281);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    padding: 8px;
    margin: 16px 0;

    &--skeleton {
        border-radius: 50%;
        background: var(--body-light-muted-color);
    }

    &--failed {
        color: white;
        background: linear-gradient(135deg, #F45A68, #F96C7A);
    }
}

.tx-mobile-overview-nft {
    width: 128px;
    height: 128px;
    border-radius: 12px;
    margin: 20px 0;
    background-color: var(--badge-grey-background-color);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        color: var(--body-text-color);
        width: 42px;
        height: 42px
    }
}
.tx-mobile-overview-swap {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
}
.tx-mobile-overview-swap-logo {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: 5px solid var(--card-background);
    background-color: var(--card-background);

    &--left {
        z-index: 1;
        transform: translateX(25px);
    }
    &--right {
        z-index: 2;
        transform: translateX(-25px);
    }
}
.tx-mobile-overview-swap-arrow {
    width: 22px;
    height: 22px;
    color: var(--body-muted-text-color);
}
</style>
